import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const StyledAlertValidationInstallation = styled.div<{ theme: { token: GlobalToken } }>`
  position: fixed;
  top: 1.5rem;
  left: 50%;
  transform: translate(-50%, 0%);
  z-index: 4;
  min-width: 450px;

  .ant-alert-action {
    align-self: flex-end;
    padding: 0px ${({ theme: { token } }) => token.padding}px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  @media (max-width: ${({ theme: { token } }) => token.screenMD}px) {
    margin: 0 0 ${({ theme: { token } }) => token.marginLG}px 0;
  }
`;
